import { ModalNames } from "~/jsx/context/ModalNames";
import { XModal } from "../design";

export const XPlayerLeaderModal = () => {
  return <XModal name={ModalNames.playerLeader}>{null}</XModal>;
};
